export default __webpack_public_path__ + "static/media/ads.0085b47f.jpg";